module.exports = __webpack_public_path__ + "media/categories/4021-9ef739aa.svg";